<template lang="html">
  <div id="stepper-container">
    <div class="w-full">
      <input class="form-input px-1" v-model="currentValue" maxlength="3" :type="isAlphanumeric ? 'text' : 'number'" max="999" @keyup="validateInput"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "vertical-stepper",
  props: {
    stepperValue: {},
    isAlphanumeric: {
      type: Boolean,
      required: false,
      default: false
    },
    maxValue: {
      type: Number,
      required: false,
      default: 999,
    }
  },
  data(){
    return {
      currentValue: this.stepperValue,
    }
  },
  computed: {
    displayValue() {
      return this.getCurrentValue()
    }
  },
  watch:{
    stepperValue(){
      this.currentValue = this.stepperValue;
    },
    currentValue(){
      let validValue = this.currentValue;
      if(this.isAlphanumeric){
        validValue = validValue.toUpperCase();
        // this.currentValue = (this.currentValue + 1 + this.maxValue - 1) % this.maxValue + 1
      }
      else{
        if (parseInt(validValue) > this.maxValue) validValue = this.maxValue
      }
      this.currentValue = String(validValue)
      this.$emit('update:stepper-value', this.currentValue);
    }
  },
  methods: {
    validateInput(e){
      if(this.isAlphanumeric){
      }
    },
    getCurrentValue: function () {
      if(this.isAlphanumeric){
        return String.fromCharCode(this.currentValue- 1 + 65);
      }else{
        return  this.currentValue;
      }
    },
  }
}
</script>

<style scoped>

</style>